<template>
    <CRow>
        <CCol col="12" lg="8" xl="6">
            <div :class="this.$func.storyblok2Css(blok)">
                <h4 class="mb-0">{{blok.headline}}</h4>
                <span class="text-small">{{blok.date}}</span>
                <hr class="mt-1 mb-2" />
                <rich-text-renderer :document="blok.text" />
            </div>
        </CCol>
    </CRow>
</template>

<script>
    export default {
        props: ['blok']
    }
</script>